import {ListNotifications} from '../../../fragments/admin/notifications/ListNotifications'

const AdminNotifications = () =>{
    return (
        <main>
            <ListNotifications/>
        </main>
    )
}
export default AdminNotifications